export const en = {
  profile: {
    taskDetailLayout: 'Task Detail Layout',
    selectTaskDetailLayout: 'Task Detail Layout',
    layoutScroll: 'Scroll',
    layoutScrollDesc: 'All sections on one long page',
    layoutTabs: 'Tabs',
    layoutTabsDesc: 'Split into Details, Documents, Checker & Report tabs',
    title: 'Profile',
    personalInfo: 'Personal Info',
    notifications: 'Notifications',
    faceId: 'Face ID',
    language: 'Language',
    logout: 'Log out',
    loggingOut: 'Logging out...',
    currentLanguage: 'English',
    profileUpdated: 'Profile updated successfully',
    failedUpdate: 'Failed to update profile',
    editPersonalInfo: 'Edit Personal Info',
    name: 'Name',
    phone: 'Phone number',
    email: 'Email',
    passwordOptional: 'Password (optional)',
    selectLanguage: 'Select Language',
    ringtone: 'Ringtone',
    selectRingtone: 'Select Ringtone',
    preview: 'Preview',
    ringtoneClassic: 'Classic',
    ringtoneIphone: 'iPhone',
    ringtoneGentle: 'Gentle',
    ringtoneDigital: 'Xylophone',
    ringtoneBeep: 'Beep (Default)',
    english: 'English',
    indonesian: 'Indonesian',
    changePhoto: 'Change Profile Photo',
    fromGallery: 'Choose from Gallery',
    takePhoto: 'Take Photo',
    cropTitle: 'Adjust Photo',
    cropHint: 'Drag & pinch to adjust',
    cropConfirm: 'Use Photo',
    photoUpdateFailed: 'Failed to upload photo',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    ok: 'OK',
    loading: 'Loading...',
    processing: 'Processing...',
    saving: 'Saving...',
    deleting: 'Deleting...',
    submitting: 'Submitting...',
    saveProgress: 'Save Progress',
    savingProgress: 'Saving Progress...',
    submit: 'Submit',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    goBack: 'Go Back',
    search: 'Search...',
    description: 'Description',
    location: 'Location',
    createdBy: 'Created By',
    attachments: 'Attachments',
    required: 'Required',
    optional: 'Optional',
    others: 'Others',
    pdfPreviewNotSupported: 'PDF preview is not supported in this browser.',
    accessDenied: 'Access Denied',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    updateAvailable: 'An update is available.',
    updateNow: 'Update Now',
    updating: 'Updating app...',
  },
  offline: {
    backOnline: 'Back online',
    syncing: 'Syncing {count} items…',
    offlineMode: 'Offline Mode',
    pendingItems: '{count} items pending',
    share: '↑ Share',
    sharedSuccess: '✓ Shared successfully',
    savedToDownloads: '✓ Saved to Downloads',
    exportFailed: 'Export failed',
    shareExportTitle: 'Share Export File',
    fileSavedToDownloads: '✓ File saved to Downloads folder',
    shareFile: 'Share File',
    shareFileDesc: 'Send via WhatsApp, Email, etc. (with file attached)',
    howToShare: 'How to share the file:',
    howToShareDesc: 'Open File Manager → Downloads folder → long press {filename} → select Share → choose WhatsApp or Email',
    close: 'Close',
    cancelFailedTitle: 'Cancel Failed Data?',
    cancelFailedDesc: 'Failed data will be permanently deleted from the queue. Make sure you have already exported the file if it is still needed.',
    no: 'No',
    yesCancelBtn: 'Yes, Cancel',
    failedBannerMsg: '{count} items failed to send — export and send to admin',
    cancelFailedTooltip: 'Cancel failed data',
    cancelFailedBtn: '✕ Cancel',
  },
  form: {
    chooseTaskType: 'Choose Task Type',
    chooseClient: 'Choose Client',
    searchClient: 'Search client...',
    chooseVessel: 'Choose Vessel',
    searchVessel: 'Search vessel...'
  },
  section: {
    requiredAttachments: 'Task Checklist',
  },
  signIn: {
    welcome: 'Welcome Back!',
    emailPlaceholder: 'brileyhenderson@mail.com',
    passwordPlaceholder: '••••••••',
    button: 'Sign In',
    signingIn: 'Signing in...',
    validation: {
      fillAll: 'Please fill in all fields',
      validEmail: 'Please enter a valid email',
      passwordLength: 'Password must be at least 6 characters',
    }
  },
  tenantSelect: {
    title: 'Select Workspace',
    subtitle: 'Choose the workspace to sign in to',
    loading: 'Signing in...',
    back: 'Back to login',
  },
  forgotPassword: {
    title: 'Forgot Password',
    subtitle: 'Enter your registered email address. We will send a password reset link via WhatsApp.',
    emailLabel: 'Email Address',
    emailPlaceholder: 'your@email.com',
    send: 'Send Reset Link',
    sending: 'Sending...',
    successTitle: 'Link Sent!',
    successMessage: 'If this email is registered, a reset link has been sent to the associated WhatsApp number.',
    backToLogin: 'Back to Login',
    linkText: 'Forgot password?',
  },
  resetPassword: {
    title: 'Create New Password',
    subtitle: 'Enter your new password below.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    submit: 'Save Password',
    submitting: 'Saving...',
    success: 'Password updated successfully! You can now log in.',
    mismatch: 'Passwords do not match.',
    minLength: 'Password must be at least 8 characters.',
    invalidToken: 'This reset link is invalid or has expired.',
  },
  createTask: {
    title: 'Create Task',
    checkAll: 'Check All',
    uncheckAll: 'Uncheck All',
    searchChecklist: 'Search checklist...',
    descriptionPlaceholder: 'Description...',
    totalDuration: 'Total Duration',
    manualDurationCheckbox: 'Input duration manually',
    manualDurationPlaceholder: 'Duration in minutes',
    startDate: 'Start Date',
    manualDurationLabel: 'Duration',
    attachment: 'Task Attachment (Optional)',
    tapToUpload: 'Tap to upload document',
    followUpFor: 'Follow-up for Task',
    isUrgent: 'Mark as Urgent',
    isMaintenance: 'Mark as Maintenance',
    checker: 'Checker (Optional)',
    chooseChecker: 'Choose Checker',
    button: 'Create Task',
    alerts: {
      missingUserId: 'Cannot create task: User ID is missing. Please try logging in again.',
      fillRequired: 'Please fill in all required fields',
      success: 'Task created successfully!',
      failed: 'Failed to create task',
      fetchClientsFailed: 'Failed to load client list. Check your connection and try reloading this page.',
      fetchVesselsFailed: 'Failed to load vessel list. Check your connection and try reloading this page.',
    },
    noChecklistFound: 'No matching checklist found.'
  },
  taskDetails: {
    tabDetail: 'Details',
    tabDocuments: 'Documents',
    tabChecker: 'Checker',
    tabReport: 'Report',
    tabNeedsAction: 'Needs your action',
    tabDocumentsEmpty: 'No documents for this task yet',
    tabReportEmpty: 'No task reports yet',
    title: 'Task Details',
    currentStatus: 'Current Status',
    assignTo: 'Assign to',
    attachment: 'Task Attachment',
    searchUser: 'Search user...',
    noSpecificAttachments: 'No specific checklist configured.',
    taskType: 'Task Type',
    createdDate: 'Created Date',
    notFound: 'Task Not Found',
    notFoundDesc: 'The task you are looking for does not exist or has been deleted.',
    totalDuration: 'Total Duration',
    estimatedDuration: 'Estimated Duration',
    processingTime: 'Processing Time',
    approvedBy: 'Approved by',
    completedDate: 'Completed Date',
    assignedBy: 'Assigned By',
    assignedTo: 'Assigned To',
    checker: 'Checker',
    taskReports: 'Task Reports',
    reviewedBy: 'Reviewed by',
    submittedBy: 'Submitted by',
    notes: 'Notes',
    followUpTask: 'Follow-up Task',
    followUpOf: 'Follow-up of',
    createFollowUp: 'Create Follow-up Task',
    additionalAttachments: 'Additional Attachments',
    downloadFile: 'Download File',
    deleteTask: 'Delete Task',
    deleteComment: 'Delete Comment',
    deleteCommentConfirmation: 'Deleted comments cannot be recovered.',
    replyToAttachmentPlaceholder: 'Reply to this attachment...',
    noAttachmentsSubmitted: 'No checklist items submitted yet.',
    uploadedBy: 'Uploaded by',
    noMatchingUsers: 'No matching users',
    oldFile: 'Old file:',
    tapToReplace: 'Tap to replace document',
    usersSelected: 'Users Selected',
    deleteConfirmation: 'Are you sure you want to delete this task? This action cannot be undone.',
    awaitingReport: 'Awaiting report',
    reviewModal: {
      approveTitle: 'Approve Task',
      rejectTitle: 'Reject Task',
      incompleteTitle: 'Mark as Incomplete',
      completeTitle: 'Complete Task',
      failedTitle: 'Fail Task',
      score: 'Score (0-100)',
      enterScore: 'Enter score',
      addNotes: 'Add review notes...',
    },
    buttons: {
      approve: 'Approve',
      reject: 'Reject',
      incomplete: 'Incomplete',
      complete: 'Complete',
      failed: 'Failed',
      submitReport: 'Create Report',
      editDraft: 'Edit Draft',
      startWork: 'Start Work',
      pendingWork: 'Pending',
      review: 'Review',
    },
    addCommentPlaceholder: 'Give a response...',
    send: 'Send',
    client: 'Client',
    vessel: 'Vessel',
    vesselHistory: 'Vessel Task History',
    noVesselTasks: 'No tasks found for this vessel.',
    file: 'File',
    assignFailed: 'Failed to assign user',
    taskUpdated: 'Task updated successfully',
    taskUpdateFailed: 'Failed to update task',
    taskDeleted: 'Task deleted successfully',
    taskDeleteFailed: 'Failed to delete task',
    notAssignedError: 'You are not registered as a worker for this task. Please add your name to the "Assigned To" section first.',
    waitingPreparation: 'Waiting for Preparation',
    waitingPreparationMsg: 'Task cannot be started because the Checker has not completed the preparation (Checklist/Notes) yet.',
    notAuthorizedSubmit: 'You are not authorized to submit a report for this task because you are not an assigned worker.',
    checkerNotDoneMsg: 'Task cannot be completed yet. The checker has not finished the inspection process.',
    alerts: {
      approved: 'Task approved successfully',
      rejected: 'Task rejected successfully',
      incompleted: 'Task marked as incomplete',
      started: 'Task started successfully',
      pendinged: 'Task set to on hold',
      cancelled: 'Task cancelled successfully',
      actionFailed: 'Action failed. Please try again.',
    },
    cancelModal: {
      title: 'Cancel Task',
      noteLabel: 'Cancellation reason (required)',
      notePlaceholder: 'E.g.: Task no longer needed, replaced by another task, etc.',
      noteRequired: 'Please provide a cancellation reason.',
      confirmBtn: 'Cancel Task',
    },
    resumedNote: 'Task work has been resumed',
    showReply: 'Reply',
    tabTesting: 'Testing',
    gpsTitle: 'Vessel position & engine (GPS)',
    gpsUpdatedAt: 'Updated {time}',
    gpsRefresh: 'Refresh',
    gpsLoadFailed: 'Failed to load vessel positions',
    gpsMoving: 'Moving',
    gpsStopped: 'Stopped',
    gpsSpeed: 'Speed / heading',
    gpsPositionTime: 'Last position',
    gpsCoordinates: 'Coordinates (open in Maps)',
    gpsDevice: 'Device',
    gpsMinutesAgo: '{n} min ago',
    gpsHoursAgo: '{n} h ago',
    gpsDaysAgo: '{n} d ago',
    gpsNoEngineData: 'No engine data from this device',
    gpsEngineUpdated: 'Engine data {time}',
    gpsStale: 'not updated recently',
    gpsRpmTitle: 'Engine RPM',
    gpsEngineN: 'Engine {n}',
    gpsEngineRunning: 'Running',
    gpsEngineOff: 'Off',
    gpsFuelTitle: 'Fuel (consumption / flow / return)',
    gpsNoSerial: 'Serial Number is not registered yet, please contact the administrator',
    gpsNoApplicationId: 'Application ID is not registered yet, please contact the administrator',
    gpsDeviceNotRegistered: 'Device is not registered in the matching application',
    gpsTokenInvalid: 'Token is no longer valid',
    gpsAutoRefresh: 'Auto refresh every {n}s',
  },
  taskSubmission: {
    title: 'Submit Report',
    reportingFor: 'Reporting for Task:',
    describeWork: 'Describe the work done...',
    addFiles: '+ Add Files',
    noFiles: 'No files added yet.',
    locationAcquired: 'Location acquired',
    fetchingLocation: 'Fetching location...',
    before: 'Before',
    after: 'After',
    uploadScreen: {
      example: 'Example',
      imageExample: 'Image Example',
      yourFile: 'Your File',
      tapToUpload: 'Tap to upload',
    },
    alerts: {
      progressSaved: 'Progress saved successfully!',
      saveProgressFailed: 'Failed to save progress.',
      missingDescription: 'Please enter a description',
      locationRequired: 'Location is required. ',
      missingInformation: 'Please complete required fields: ',
      submissionSuccess: 'Task report submitted successfully!',
      submissionFailed: 'Failed to submit report. Please try again.',
      offlineSaved: 'Report saved offline and will be sent when connected.',
    },
  },
  taskList: {
    title: 'Task List',
    searchPlaceholder: 'Search tasks or #ID...',
    new: 'NEW',
    update: 'UPDATE',
    loading: 'Loading tasks...',
    noTasksFound: 'No tasks found matching your search.',
    noTasksAvailable: 'No tasks available.',
    loadingMore: 'Loading more...',
    allDataLoaded: 'All tasks loaded',
    overdue: 'Overdue',
    newMessage: '💬 New Message',
  },
  personalData: {
    title: 'Personal Data',
    leaveBalance: 'Leave Balance',
    used: 'Used',
    total: 'Total',
    remaining: 'Remaining',
    days: 'Days',
    personalInfo: 'Personal Information',
    hrMenu: 'HR Menu',
    attendance: 'Attendance',
    leave: 'PTO',
    payslip: 'Payslip',
    reimburse: 'Reimburse',
    email: 'Email Address',
    employeeId: 'Employee ID',
    joinDate: 'Join Date',
    phone: 'Phone Number',
    department: 'Department',
    activeEmployee: 'Active Employee',
    uploadPhoto: 'Tap to upload photo',
    leaveRequest: 'Leave Request',
    correctionRequest: 'Attendance Correction',
    loanRequest: 'Loan',
    documents: 'My Documents',
    requestLeaveBtn: 'Request Leave',
    cancel: 'Cancel',
    uploading: 'Uploading...',
    addDocument: 'Add Document',
    averageScore: 'Average Score',
    pts: 'pts',
    vsLastMonth: 'vs last month',
    noScoreData: 'No data',
    tasks: 'tasks',
    businessCard: 'Business Card',
    qrCode: 'QR Code',
    showQr: 'Show QR',
    showCard: 'Show Card',
    tapToSeeIdCard: 'Tap to see ID Card ↺',
    idCard: 'ID CARD',
    idNumber: 'ID Number',
    tapToSeeBusinessCard: 'Tap to see Business Card ↺',
    employeeLabel: 'Employee',
    inbox: 'Inbox',
  },
  leaveHistory: {
    title: 'Request List',
    requestList: 'Request List',
    tabMine: 'My Requests',
    tabTeam: 'Team Requests',
    allMonths: 'All Months',
    allYears: 'All Years',
    filterByName: 'Search by name...',
    loading: 'Loading data...',
    noData: 'No leave requests found.',
    loadingMore: 'Loading more data...',
    allDataLoaded: 'All data loaded',
    hasAttachment: 'Attachment',
    leaveBalance: 'Leave Balance',
    dates: 'Dates',
    duration: 'Duration',
    days: 'Days',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    status: {
      approved: 'Approved',
      rejected: 'Rejected',
      pending: 'Pending',
      cancelled: 'Cancelled'
    }
  },
  documentHistory: {
    title: 'My Documents',
    tabAll: 'All',
    tabLeave: 'Leave',
    tabCorrection: 'Correction',
    tabLoan: 'Loan',
    noData: 'No requests yet.',
    loadMore: 'Load more',
    approved: 'Approved',
    rejected: 'Rejected',
    pending: 'Pending',
    deleteConfirm: 'Are you sure you want to cancel this request? This action cannot be undone.',
    confirmTitle: 'Confirmation',
    deleteBtn: 'Yes, Cancel',
    deleteSuccess: 'Request successfully cancelled.',
    deleteError: 'Failed to cancel request.',
    correctionTitle: 'Attendance Correction',
    loanTitle: 'Loan / Kasbon',
    annualLeave: 'Annual Leave',
    sickLeave: 'Sick Leave',
    unpaidLeave: 'Absent',
    maternityLeave: 'Maternity Leave',
    marriageLeave: 'Marriage Leave',
    months: 'months',
    weeks: 'weeks',
  },
  notification: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    noNotifications: 'No notifications yet.',
    actionRequired: 'Action Required',
    noActionRequired: 'No notifications requiring action',
    actionTag: 'Action',
  },
  correctionDetail: {
    title: 'Attendance Correction Detail',
    currentStatus: 'Request Status',
    attendanceInfo: 'Corrected Attendance Data',
    date: 'Date',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    breakOut: 'Break Start',
    breakIn: 'Break End',
    reason: 'Reason for Correction',
    evidence: 'Evidence / Photo',
    reviewInfo: 'Review Info',
    reviewedBy: 'Reviewed by',
    rejectReason: 'Rejection Reason',
    submittedAt: 'Submitted',
    approved: 'Approved',
    rejected: 'Rejected',
    pending: 'Pending',
    cancelBtn: 'Cancel Request',
    confirmTitle: 'Confirmation',
    cancelConfirm: 'Are you sure you want to cancel this correction request?',
    cancelSuccess: 'Correction request successfully cancelled.',
    cancelError: 'Failed to cancel request.',
  },
  loanDetail: {
    title: 'Loan / Kasbon Detail',
    currentStatus: 'Request Status',
    loanInfo: 'Loan Details',
    amount: 'Loan Amount',
    tenor: 'Tenor',
    months: 'Months',
    weeks: 'Weeks',
    reason: 'Reason',
    adminNote: 'Admin Note',
    submittedAt: 'Submitted',
    updatedAt: 'Updated',
    approved: 'Approved',
    rejected: 'Rejected',
    pending: 'Pending',
    cancelBtn: 'Cancel Request',
    cancelBtnConfirm: 'Yes, Cancel',
    confirmTitle: 'Confirmation',
    cancelConfirm: 'Are you sure you want to cancel this loan request?',
    cancelSuccess: 'Loan request successfully cancelled.',
    cancelError: 'Failed to cancel request.',
    requested: 'requested',
  },
  loanRequest: {
    title: 'Loan / Kasbon Request',
    amount: 'Loan Amount (Rp)',
    amountPlaceholder: 'e.g. 5000000',
    tenor: 'Tenor',
    tenorPlaceholder: 'e.g. 3',
    months: 'Months',
    weeks: 'Weeks',
    reason: 'Reason',
    reasonPlaceholder: 'Explain the purpose of this loan request...',
    submit: 'Submit Request',
    submitting: 'Submitting...',
    success: 'Loan request submitted successfully!',
    error: 'Failed to submit request.',
    validation: 'Please fill in the loan amount and tenor.',
  },
  leaveRequest: {
    title: 'Leave Request',
    leaveType: 'Leave Type',
    annualLeave: 'Annual Leave',
    sickLeave: 'Sick Leave',
    unpaidLeave: 'Absent',
    maternityLeave: 'Maternity Leave',
    marriageLeave: 'Marriage Leave',
    dates: 'Dates',
    startDate: 'Start Date',
    endDate: 'End Date',
    reason: 'Reason',
    reasonPlaceholder: 'Reason for leave...',
    submit: 'Submit Request',
    submitting: 'Submitting...',
    success: 'Leave request submitted successfully!',
    error: 'Failed to submit leave request.',
    validation: 'Please fill all required fields (Leave type, start date, end date, reason).',
    attachment: 'Attachment (Optional)',
    tapToUpload: 'Tap to upload document'
  },
  leaveDetails: {
    title: 'Request Details',
    notFound: 'Leave data not found',
    successWithdraw: 'Request successfully withdrawn/deleted',
    successApproved: 'Leave successfully approved',
    successRejected: 'Leave successfully rejected',
    errorAction: 'An error occurred. Please try again.',
    currentStatus: 'Current Status',
    status: {
      approved: 'Approved',
      rejected: 'Rejected',
      pending: 'Pending Approval',
      cancelled: 'Cancelled'
    },
    modal: {
      cancelTitle: 'Cancel Request',
      cancelMsg: 'Are you sure you want to cancel this leave request?',
      cancelBtn: 'Cancel Request',
      approveTitle: 'Approve Request',
      approveMsg: 'Are you sure you want to approve this leave request?',
      approveBtn: 'Approve',
      rejectTitle: 'Reject Request',
      rejectMsg: 'Are you sure you want to reject this leave request?',
      rejectBtn: 'Reject'
    },
    leaveInfo: 'Leave Information',
    leaveType: 'Leave Type',
    dates: 'Dates',
    leaveBalance: 'Leave Balance',
    duration: 'Duration',
    days: 'Days',
    reason: 'Reason for Leave',
    submittedBy: 'Submitted By',
    attachmentAvailable: 'Attachment Available',
    view: 'View',
    createdAt: 'Created at',
    processing: 'Processing...',
    approvedBy: 'Approved by',
    rejectedBy: 'Rejected by',
  },
  activity: {
    title: 'Activity',
    survey: 'Survey',
    meeting: 'Meeting',
    marketing: 'Marketing',
    recent: 'Recent Activities',
    createTitle: 'Create Activity',
    validation: {
      fillRequired: 'Title and DateTime are required fields.'
    },
    alerts: {
      success: 'Activity created successfully!',
      failed: 'Failed to create activity. Please try again.'
    },
    titlePlaceholder: 'Enter activity title',
    datetimePlaceholder: 'Select Date and Time',
    locationPlaceholder: 'e.g. Meeting Room A / Client Site',
    addressPlaceholder: 'Full address (optional)',
    tapToUpload: 'Tap to upload attachment',
    descriptionPlaceholder: 'Write a detailed description of the activity...',
    deleteTitle: 'Delete Activity',
    deleteConfirm: 'Are you sure you want to delete this activity?',
    noActivities: 'No activities found.',
    loadingMore: 'Loading more...',
    allLoaded: 'All activities loaded',
    justNow: 'Just now',
    minsAgo: 'mins ago',
    hoursAgo: 'hours ago',
    daysAgo: 'days ago',
    monthsAgo: 'months ago',
    yearsAgo: 'years ago'
  },
  attendance: {
    title: 'Attendance',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    breakOut: 'Start Break',
    breakIn: 'End Break',
    history: 'Attendance History',
    checkInTime: 'Check-in Time',
    checkOutTime: 'Check-out Time',
    breakOutTime: 'Break-out Time',
    breakInTime: 'Break-in Time',
    status: 'Status',
    noData: 'No attendance records found.',
    successCheckIn: 'Successfully checked in!',
    successCheckOut: 'Successfully checked out!',
    successBreakOut: 'Successfully started break!',
    successBreakIn: 'Successfully ended break!',
    takePhoto: 'Take Photo',
    present: 'Present',
    fetchingLocation: 'Fetching location...',
    addressNotFound: 'Address not found',
    notePlaceholder: 'Notes (Optional)...',
    noBreakIn: 'Did not end break',
    noBreakOut: 'Did not take a break',
    validation: {
      photoRequired: 'Please take a photo (proof of attendance).'
    },
    alerts: {
      locationNotAcquired: 'Location not acquired. Please enable GPS.',
      outOfRange: 'You are outside the attendance area.',
      alreadyCompleted: 'You have completed your attendance for today!',
      locationError: 'Failed to get location. Please enable GPS and allow permission.',
      noGeolocation: 'Geolocation is not supported by this browser.'
    },
    offlineSaved: 'Attendance saved offline and will be sent when connected.',
    prevDayWarning: 'You have an incomplete attendance from',
    prevDayCheckoutFirst: 'Please check out to allow check-in today.',
    businessTrip: 'Business Trip (Outside Office)',
    businessTripApproved: 'Business Trip Approved',
    businessTripRejected: 'Business Trip Rejected',
    businessTripPending: 'Business Trip Pending Approval',
    cancelledByLeave: 'This attendance is cancelled due to an approved leave.',
    hrNoteTitle: 'HR Note',
    hrNoteBy: 'By',
    hrNoteTodayDesc: 'HR has recorded a note for today, so you don\x27t need to check in.',
    correction: {
      title: 'Attendance Correction Request',
      dateLabel: 'Date',
      checkInLabel: 'Check-in Time',
      checkOutLabel: 'Check-out Time',
      breakOutLabel: 'Break-out Time',
      breakInLabel: 'Break-in Time',
      reasonLabel: 'Reason',
      reasonPlaceholder: 'Explain the reason for attendance correction...',
      evidenceLabel: 'Photo Evidence',
      evidenceButton: 'Select Photo',
      submit: 'Submit Correction',
      submitSuccess: 'Correction request submitted successfully!',
      sectionTitle: 'Correction Request',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      rejectedReason: 'Rejection Reason',
      optional: 'Optional',
      cancelRequest: 'Cancel Request',
      cancelConfirm: 'Are you sure you want to cancel this correction request?',
      validation: {
        required: 'Date and reason are required.'
      }
    }
  },
  notFound: {
    title: 'Page Not Found',
    description: 'Oops! The page you are looking for does not exist or has been moved.',
    backToHome: 'Back to Home'
  },
  marketingActivity: {
    title: 'Marketing Activities',
    createTitle: 'Create Marketing Activity',
    type: 'Activity Type',
    selectType: 'Select Activity Type',
    companyName: 'Company Name',
    enterCompany: 'Enter company name',
    subject: 'Subject',
    enterSubject: 'Enter subject',
    dateAndTime: 'Date & Time',
    description: 'Description',
    descriptionPlaceholder: 'Write a detailed description...',
    location: 'Location',
    submit: 'Submit Activity',
    validation: {
      fillRequired: 'Date, Activity Type, Company Name, and Subject are required.'
    },
    alerts: {
      success: 'Marketing activity created successfully!',
      failed: 'Failed to create activity. Please try again.'
    },
    waitingLocation: 'Please wait, getting location coordinates...',
    activityInfo: 'Activity Info',
    detailTitle: 'Activity Details',
    loading: 'Loading details...',
    notFound: 'Activity not found.',
    noAddress: 'No address provided',
    participants: 'Participants',
    minutesTitle: 'Meeting Minutes',
    noActivities: 'No Activities',
    noActivitiesDesc: "You haven't created any marketing activities yet.",
    add: 'Add',
    participantName: 'Participant Name',
    position: 'Position',
    noParticipants: 'No participants added yet.',
    signed: 'Signed',
    sign: 'Sign',
    issue: 'Issue *',
    date: 'Date',
    status: 'Status',
    selectStatus: 'Select Status',
    action: 'Action',
    department: 'Department',
    pic: 'PIC',
    target: 'Target',
    noMinutes: 'No minutes recorded yet.',
    added: 'Added:',
    participantSignature: 'Participant Signature',
    clear: 'Clear',
    saveSignature: 'Save Signature',
    signaturePreview: 'Signature Preview',
    documentation: 'Documentation',
    addDocumentation: 'Add Documentation',
    noDocumentation: 'No documentation added yet.',
    deleteParticipantTitle: 'Delete Participant',
    deleteParticipantConfirm: 'Are you sure you want to delete this participant?',
    deleteMinuteTitle: 'Delete Minute',
    deleteMinuteConfirm: 'Are you sure you want to delete this minute?',
    deleteDocumentationTitle: 'Delete Documentation',
    deleteDocumentationConfirm: 'Are you sure you want to delete this document?',
    deleteActivityTitle: 'Delete Activity',
    deleteActivityConfirm: 'Are you sure you want to permanently delete this activity?'
  },
  eventActivity: {
    title: 'Event Activities',
    menuLabel: 'Event',
    createTitle: 'Create Event Activity',
    detailTitle: 'Event Detail',
    date: 'Date',
    description: 'Description',
    descriptionPlaceholder: 'Describe the event...',
    location: 'Location',
    photos: 'Photos',
    addPhotos: 'Add Photos',
    participants: 'Event Participants',
    participantName: 'Participant Name',
    position: 'Position / Role',
    add: 'Add',
    noParticipants: 'No participants added yet.',
    noActivities: 'No Events Yet',
    noActivitiesDesc: "You haven't created any events yet.",
    loading: 'Loading events...',
    loadingMore: 'Loading more...',
    allLoaded: 'All events loaded',
    submit: 'Create Event',
    saving: 'Saving...',
    waitingLocation: 'Please wait, getting location coordinates...',
    alerts: {
      success: 'Event activity created successfully!',
      failed: 'Failed to create event. Please try again.'
    },
    validation: {
      fillRequired: 'Date is required.'
    },
    deleteTitle: 'Delete Event',
    deleteConfirm: 'Are you sure you want to delete this event?',
    deleteParticipantTitle: 'Delete Participant',
    deleteParticipantConfirm: 'Are you sure you want to delete this participant?',
    participants_count: 'Participants',
    photoCount: 'photos',
    creator: 'Created by',
    noPhotos: 'No photos uploaded.',
    expandImage: 'View Photo',
    searchUser: 'Search app user...',
    noUsersFound: 'No users found',
    dateTime: 'Date & Time'
  },
  checkerTask: {
    preparationTitle: 'Preparation',
    inspectionTitle: 'Task Inspection',
    checkerChecklist: 'Checker Checklist',
    searchChecklist: 'Search checker checklist...',
    preparationNotesTitle: 'Preparation Notes',
    inspectionNotesTitle: 'Inspection Notes',
    addPreparationNotes: 'Add preparation notes...',
    addInspectionNotes: 'Add inspection notes...',
    savePreparation: 'Save (Preparation)',
    saveInspection: 'Save (Inspection)',
    submitPreparation: 'Submit (Preparation)',
    submitInspection: 'Submit (Inspection)',
    failedToSave: 'Failed to save ',
    statusChecked: 'Checked',
    statusPrepared: 'Prepared',
    statusNotPrepared: 'Not Prepared',
    statusPending: 'Items Missing',
    noChecklistItems: 'No inspection checklist items yet.',
    noChecklistSetup: 'No checklist data. Please set up checker checklists first.',
    btnPreparation: 'Preparation',
    btnInspection: 'Inspection',
    addChecklistTitle: 'Add Checker Checklist',
    addChecklistPlaceholder: 'e.g., Safety Helmet, Wrench...',
    addChecklistCategoryLabel: 'Category',
    addChecklistCategoryPlaceholder: 'No category',
    categoryTools: 'Tools',
    categoryInstallationItems: 'Installation Items',
    categoryConsumables: 'Consumables',
    preparedAt: 'Prepared at',
    checkedAt: 'Checked at',
    preparationNote: 'Preparation Note:',
    checkerNote: 'Checker Note:',
    pendingItemsTitle: 'The following items need to be completed:',
    btnConfirmReplacement: 'Confirm Replacement Items',
    confirmReplacementTitle: 'Confirm Replacement Items',
    missingItemsLabel: 'Items that need to be completed:',
    replacementNoteLabel: 'Replacement item description',
    replacementNotePlaceholder: 'Explain the replacement items provided...',
    photoEvidenceLabel: 'Photo evidence (optional, max. 5)',
    btnSubmitConfirmation: 'Send Confirmation',
    btnSubmitting: 'Sending...',
    confirmSuccess: 'Confirmation sent. The checker will re-inspect shortly.',
    confirmFailed: 'Failed to send confirmation',
    itemMissingSuffix: '— missing',
    checkerRole: 'Checker',
    checklistSaved: 'Checker checklist saved successfully',
    checklistSaveFailed: 'Failed to save checker checklist',
    checklistAddFailed: 'Failed to add checker checklist item',
    replacementSubmittedTitle: 'Replacement Submitted',
    replacementNoteLabel2: 'Note:',
    replacementPhotosLabel: 'Photo Evidence:',
    btnConfirmAccept: 'Accept Replacement Items',
    replacementAccepted: 'Replacement items confirmed. Checker status set to checked.',
    replacementAcceptFailed: 'Failed to confirm replacement items',
    waitingUserResponse: 'Waiting for worker\'s replacement confirmation',
    itemAcceptedNotif: 'Item accepted',
    selectedItems: 'Checked Items',
    preparedItemsTitle: 'Prepared Items',
    checkedItemsTitle: 'Checked Items',
    items: 'items',
    itemMissingBadge: 'Missing',
    itemInstalledBadge: 'Installed',
    itemConsumedBadge: 'Used',
    itemReturnBadge: 'Returned',
    itemNotInspectedBadge: 'Not Inspected',
    btnPreparedItems: 'Prepared Items',
    btnCheckedItems: 'Checked Items',
    btnEditPreparation: 'Edit Preparation',
    btnCancelPreparation: 'Cancel Preparation',
    cancelPreparationSuccess: 'Preparation cancelled successfully.',
    cancelPreparationFailed: 'Failed to cancel preparation.',
    selfInspectionTitle: 'Self-Inspection',
    selfInspectionNotesTitle: 'Self-Inspection Notes',
    addSelfInspectionNotes: 'Add self-inspection notes...',
    saveSelfInspection: 'Save (Self-Inspection)',
    submitSelfInspection: 'Submit (Self-Inspection)',
    btnSelfInspection: 'Self-Inspection',
    selfCheckMissingTitle: 'The following items were not found during self-inspection:',
    waitingSelfInspection: 'Waiting for the assignee to complete self-inspection before checker inspection can proceed.',
    btnSelfCheckedItems: 'Self-Inspection Items',
    selfCheckedItemsTitle: 'Self-Inspection Items',
    selfCheckReferenceNote: 'The checklist below has been pre-filled based on the assignee\'s self-inspection. Adjust it to match what you physically observe.',
    qtyLessThanPrepared: '{diff} fewer than prepared ({prepared}).',
    qtyMoreThanPrepared: '{diff} more than prepared ({prepared}).',
    serialPlaceholder: 'Serial numbers (separate with commas)',
  },
  preCheckReport: {
    title: 'Pre-Check Reports',
    titleCreate: 'Create Pre-Check Report',
    titleEdit: 'Edit Pre-Check Report',
    create: 'Create',
    loading: 'Loading...',
    saving: 'Saving...',
    empty: 'No pre-check reports yet.',
    createFirst: 'Create First Report',
    typeLabel: 'Report Type',
    typePreparation: 'Preparation',
    typeInspection: 'Inspection',
    dateLabel: 'Date',
    checklistLabel: 'Checklist Items',
    addItem: 'Add',
    addItemTitle: 'Add Checklist Item',
    addItemPlaceholder: 'e.g., Safety Helmet, Wrench...',
    addItemCategoryLabel: 'Category',
    addItemCategoryPlaceholder: 'No category',
    addItemFailed: 'Failed to add item',
    searchPlaceholder: 'Search checklist items...',
    noItems: 'No items found.',
    qty: 'Qty',
    serialNumber: 'Serial Number',
    itemChecked: 'Item checked / available',
    selectedItems: 'Selected Items',
    noteLabel: 'Notes',
    notePlaceholder: 'Add notes...',
    saveDraft: 'Save Draft',
    markReady: 'Mark as Ready',
    saveFailed: 'Failed to save report',
    statusDraft: 'Draft',
    statusReady: 'Ready',
    items: 'checklist items',
    linkedTask: 'Linked to',
    btnView: 'View / Edit',
    btnDelete: 'Delete',
    deleteConfirm: 'Delete this report?',
    deleteFailed: 'Failed to delete report',
    btnLink: 'Attach Pre-Check Report',
    linkedReportTitle: 'Pre-Check Report Attached',
    linkSuccess: 'Report successfully attached to task.',
    linkFailed: 'Failed to attach report.',
    sheetTitle: 'Select Pre-Check Report',
    sheetDesc: 'Only reports with status "Ready" are shown',
    noAvailable: 'No pre-check reports available.',
    noAvailableHint: 'Create a new report and mark it as "Ready" first.',
    btnSelect: 'Select This Report',
    btnSelected: 'Selected',
    btnUnlink: 'Cancel Attachment',
    btnChange: 'Change Document',
    unlinkSuccess: 'Attachment cancelled.',
    unlinkFailed: 'Failed to cancel attachment.',
    vesselLabel: 'Vessel (optional)',
    vesselPlaceholder: 'Select vessel...',
    searchVessel: 'Search vessel...',
    clearVessel: 'Clear selection',
  },
  schedule: {
    title: 'Schedule',
    fetchError: 'Failed to fetch tasks for schedule'
  },
  inbox: {
    title: 'Inbox',
    searchPlaceholder: 'Search messages...',
    allMessages: 'All Messages',
    unreadMessages: 'Unread',
    noMessages: 'No messages',
    emptyInbox: 'Your inbox is currently empty.'
  },
  payslip: {
    title: 'Payslip',
    slipsAvailable: 'payslips available',
    noSlipYet: 'No payslips yet',
    thisMonth: 'THIS MONTH',
    period: 'Period',
    view: 'View',
    download: 'Download',
    loadFailed: 'Failed to Load',
    retry: 'Try Again',
    noSlipTitle: 'No Payslips',
    noSlipDesc: 'Your payslip will appear here after it has been processed by HR.',
    viewAll: 'View all →',
    last3Months: 'Last 3 Months',
    allOf: 'All –',
    noSlipForYear: 'No payslips for',
    moreSlips: 'more payslips in',
    modalTitlePrefix: 'Payslip –',
    viewError: 'Failed to open payslip. Please try again.',
    downloadError: 'Failed to download payslip. Please try again.',
    fetchError: 'Failed to load payslip data.',
    monthsShort: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
  },
  surveyActivity: {
    detail: 'Survey Detail',
    notFound: 'Survey activity not found.',
    findings: 'Survey Findings',
    notes: 'Notes',
    photos: 'Photos',
    respondents: 'respondents',
    deleteTitle: 'Delete Survey?',
    deleteDesc: 'This survey activity and all its photos will be permanently deleted.',
    noLocationName: 'Survey Activity',
    checklistSection: 'Survey Checklist',
    checklistSearch: 'Search checklist...',
    checklistNoResult: 'No matching checklist found.',
    checklistEmpty: 'No checklist items added yet.',
    checklistAdd: 'Add',
    checklistAddManual: 'Add Manual',
    checklistManualPlaceholder: 'Checklist item name...',
    checklistNote: 'Note...',
    checklistValue: 'Value / Description...',
    checklistPhotoNote: 'Photo caption...',
    checklistOther: 'Other',
    checklistOtherPlaceholder: 'Enter value...',
    checklistSelectPlaceholder: '— Select —',
    checklistUploadPhoto: 'Upload Photo',
    checklistChangePhoto: 'Change Photo',
    statusDraft: 'Draft',
    statusActive: 'Link Shared',
    statusSubmitted: 'Submitted',
    submitBtn: 'Submit Survey',
    submitConfirmTitle: 'Submit Survey?',
    submitConfirmDesc: 'After submission, this survey cannot be edited. Are you sure?',
    shareBtn: 'Share Link',
    shareTitle: 'Share Survey',
    shareExpiryLabel: 'Link Expiry',
    shareNoExpiry: 'No Expiry',
    share1Day: '1 Day',
    share3Days: '3 Days',
    share7Days: '7 Days',
    share30Days: '30 Days',
    shareGenerate: 'Generate Link',
    shareRenew: 'Renew Link',
    shareCopy: 'Copy',
    shareCopied: 'Copied!',
    shareLinkLabel: 'Public Link',
    shareExpiresAt: 'Expires',
    submittedBy: 'Submitted by',
    submittedAt: 'Submitted at',
    submittedLocation: 'Location',
    submittedAnonymous: 'Submitted via public link',
  },
  publicSurvey: {
    title: 'Survey Form',
    expired: 'This survey link has expired.',
    notFound: 'Survey not found.',
    alreadySubmitted: 'This survey has already been submitted.',
    inactive: 'This survey link is not active.',
    nameLabel: 'Full Name',
    namePlaceholder: 'Enter your full name',
    contactLabel: 'Phone / Email',
    contactPlaceholder: 'Enter phone number or email',
    checklistSection: 'Survey Checklist',
    submitBtn: 'Submit Survey',
    submitting: 'Submitting...',
    successTitle: 'Thank You!',
    successDesc: 'Your survey response has been submitted successfully.',
    capturingLocation: 'Capturing your location...',
    locationLabel: 'Your Location',
    nameRequired: 'Please enter your name.',
    contactRequired: 'Please enter your phone or email.',
  },
  taskReview: {
    title: 'Review Checklist',
    taskDescription: 'Task Description',
    taskNotFound: 'Task not found',
    startedWorkAt: 'Started Work',
    submittedReportAt: 'Submitted Report',
    processingTime: 'Total Processing Time',
    targetDuration: 'Target Duration',
    suggestedScore: 'Suggested Score',
    photosApproved: 'photos approved',
    finalScore: 'Final Score',
    reviewerNotePlaceholder: 'Reviewer note (optional)...',
    additionalAttachments: 'Additional Attachments',
    overallNotes: 'Overall Notes',
    overallNotesPlaceholder: 'Overall review notes (optional)...',
    reject: 'Reject',
    complete: 'Complete',
    confirmTitle: 'Complete Task?',
    confirmDesc: 'This task will be marked as complete with the following score:',
    failedLoad: 'Failed to load review data',
    failedSubmit: 'Failed to submit review',
    errorModalTitle: 'Something Went Wrong',
    showErrorDetails: 'Show error details',
    hideErrorDetails: 'Hide error details',
    view: 'View',
    download: 'Download',
    rejectTitle: 'Reject Task?',
    rejectDesc: 'Add notes for the assignee (optional).',
    incompleteTitle: 'Mark as Incomplete?',
    incompleteDesc: 'This task will be permanently closed and cannot be resubmitted. Please provide a reason.',
    incompleteReasonPlaceholder: 'Reason (required)...',
    incompleteReasonRequired: 'Please provide a reason before marking as incomplete.',
    incomplete: 'Incomplete',
  },
  travelExpenses: {
    title: 'Travel Expense Submissions',
    addTitle: 'Travel Expense Request',
    from: 'Departure From',
    to: 'Destination',
    departure: 'Departure Date',
    returnDate: 'Return Date',
    costItems: 'Cost Breakdown',
    costType: 'Cost Type',
    amount: 'Amount',
    addRow: 'Add Row',
    submit: 'Submit',
    editTitle: 'Edit Travel Expense Request',
    saveDraft: 'Save Draft',
    draftNotice: 'Draft — not yet submitted for approval.',
    errorRequired: 'All fields are required',
    errorItems: 'Add at least 1 cost item',
    errorTask: 'Task not found',
    errorSave: 'Failed to save the request',
  },
  travelExpenseRecap: {
    addTitle: 'Travel Expense Recap',
    editTitle: 'Edit Expense Recap',
    sectionTitle: 'Travel Expense Recaps',
    tripInfo: 'Trip Information',
    from: 'Departure From',
    fromPlaceholder: 'City of origin',
    to: 'Destination',
    toPlaceholder: 'Destination city',
    departure: 'Departure Date',
    returnDate: 'Return Date',
    costItems: 'Cost Breakdown',
    description: 'Expense Description',
    descriptionPlaceholder: 'E.g. Taxi from airport to ship',
    date: 'Date',
    amount: 'Amount (Rp)',
    notes: 'Notes (optional)',
    notesPlaceholder: 'E.g. technician name, additional notes',
    photoLabel: 'Receipt / Proof (optional)',
    photoHint: 'Upload receipt or payment proof',
    photoTapHint: 'Tap photo to zoom',
    colNotes: 'Notes',
    colReceipt: 'Receipt',
    layoutTable: 'Table view',
    layoutCard: 'Card view',
    addRow: 'Add Row',
    totalLabel: 'Total Expenses',
    saveDraft: 'Save Draft',
    submit: 'Submit',
    draftNotice: 'Draft — not yet submitted for review. Click "Submit" when ready.',
    errorHeader: 'All trip information fields are required',
    errorItems: 'Add at least 1 complete expense (description, date, amount)',
    errorTask: 'Task not found',
    errorSave: 'Failed to save recap',
    createdBy: 'Created by',
    total: 'Total',
  },
  timeSheet: {
    menuTitle: 'Time Sheet',
    rows: 'rows',
    addTitle: 'Work Report',
    editTitle: 'Edit Work Report',
    saveChanges: 'Save Changes',
    vessel: 'Vessel Name',
    technician: 'Technician Name',
    location: 'Location',
    locationPlaceholder: 'e.g. North Dock',
    workItems: 'Work Details',
    date: 'Date',
    description: 'Work Description',
    descriptionPlaceholder: 'e.g. Diagnosed sensor fault',
    addRow: 'Add Row',
    submit: 'Submit',
    errorLocation: 'Location is required',
    errorItems: 'Add at least 1 complete work row (date & description)',
    errorTask: 'Task not found',
    errorSave: 'Failed to save time sheet',
    errorTechnician: 'Select at least 1 technician',
    technicianUsed: 'Already has a time sheet',
    getLocation: 'Get GPS Location',
    fetchingLocation: 'Fetching location...',
    apply: 'Apply',
    locationFetchError: 'Failed to get location. Please enable GPS and allow location permission.',
  },
  contacts: {
    title: 'Contacts',
    searchPlaceholder: 'Search users...',
    noUsersFound: 'No users found',
    calling: 'Calling...',
    micPermissionDenied: 'Microphone permission is required to make calls',
    micAccessFailed: 'Failed to access microphone. Please try again in a moment.',
    contactsTab: 'Contacts',
    chatsTab: 'Chats',
  },
  chat: {
    listTitle: 'Chats',
    noConversations: 'No conversations yet',
    searchChatsPlaceholder: 'Search name or message...',
    noResults: 'No results found',
    newChat: 'New Chat',
    newGroup: 'New Group',
    newMessage: 'New Message',
    groupNamePlaceholder: 'Group name',
    selectMembers: 'Select Members',
    createGroup: 'Create Group',
    membersSelected: 'members selected',
    errorGroupName: 'Group name is required',
    errorSelectMembers: 'Select at least 1 member',
    messagePlaceholder: 'Type a message...',
    searchPlaceholder: 'Search users...',
    send: 'Send',
    attachFile: 'Attach File',
    attachmentTooLarge: 'File size limit is 7MB',
    attachmentTypeNotAllowed: 'File type not supported',
    errorSend: 'Failed to send message',
    errorLoad: 'Failed to load conversation',
    participants: 'Participants',
    addParticipants: 'Add Participants',
    leaveGroup: 'Leave Group',
    leaveGroupConfirm: 'Are you sure you want to leave this group?',
    you: 'You',
    groupAdmin: 'Admin',
    noMessagesYet: 'No messages yet. Start the conversation!',
    today: 'Today',
    yesterday: 'Yesterday',
    groupInfo: 'Group Info',
    searchInChat: 'Search',
    searchInChatPlaceholder: 'Search in this conversation...',
    noSearchResults: 'No messages found',
    clearChat: 'Clear Chat',
    clearChatConfirm: 'Clear this chat history? It will only be removed for you, not for the other participant(s).',
    reply: 'Reply',
    edit: 'Edit',
    delete: 'Delete',
    replyingTo: 'Replying to',
    editingMessage: 'Edit message',
    edited: 'edited',
    messageDeleted: 'This message was deleted',
    deleteMessageConfirm: 'Delete this message?',
  },
  incomingCall: {
    title: 'Incoming Call',
    connecting: 'Connecting...',
    accept: 'Accept',
    reject: 'Decline',
    noSession: 'No active call session found.',
    callDeclined: 'declined the call',
    addPerson: 'Add Person',
    inviteToCall: 'Invite to Call',
    searchUser: 'Search user...',
    groupCall: 'Group Call',
    participants: 'participants',
    inviteSent: 'Invite sent',
    inviteFailed: 'Failed to send invite',
  },
  tripGroup: {
    title: 'Trip Group',
    hint: 'Tasks for the same customer handled in one trip. Shared travel documents and the checker packing list apply to every task in the group.',
    empty: 'This task is not in a trip group yet.',
    addTask: 'Add Task',
    chooseTask: 'Choose a task on the same trip',
    noCandidates: 'No other active tasks for this customer.',
    needClient: 'Set the customer on this task first.',
    currentTask: 'This task',
    remove: 'Remove',
    removeConfirm: 'Remove this task from the trip group? Its own documents leave with it and it keeps a copy of the packing list.',
    checkerConflictTitle: 'Different checker',
    checkerConflictMsg: 'This task\'s checker ({task}) differs from the group checker ({group}). Change this task\'s checker to {group}?',
    changeChecker: 'Change checker',
    mergeTitle: 'Merge packing list',
    mergeMsg: 'This task already has its own checker preparation. Quantities of the same items will be added together:',
    mergeConfirm: 'Merge',
    hasPreparation: 'Has preparation',
    checker: 'Checker',
    sharedDoc: 'Shared',
    sharedFrom: 'Shared from',
    shareToggle: 'Shared document for the trip group',
    shareHint: 'Visible and editable from every task in the group.',
    lastEditedBy: 'Last edited by',
    vessel: 'Vessel',
    vesselShared: 'Shared',
    installedTitle: 'Installed Serial Numbers',
    installedHint: 'Record the serial numbers actually installed on this vessel. Only these are linked to the product data.',
    pickFromPrepared: 'Brought by the checker',
    usedOn: 'Installed on',
    manualEntry: 'Other serial number',
    itemLabel: 'Item',
    chooseItem: 'Choose item',
    serialPlaceholder: 'Serial number',
    add: 'Add',
    noneInstalled: 'No serial numbers recorded yet.',
    noPrepared: 'No installation items in the packing list.',
    serialUsed: 'This serial number is already recorded as installed on {vessel}',
    linkedTo: 'Linked to',
    tab: 'Trip',
    menuAdd: 'Add to Trip Group',
    chip: 'Trip · {n} vessels',
  },
};
